import {asyncActionsFactory} from '@wix/wix-events-commons-statics'
import {MemberPageState, StoreExtraArgs} from '../types/state'

export const createAsyncAction = asyncActionsFactory<MemberPageState, StoreExtraArgs>()
